import { lazy } from "react";
import WithSuspense from "../components/Loaders/WithSuspense";
import { PUBLIC_PATHS, PRIVATE_PATHS } from "./constants";
import { Navigate } from "react-router-dom";

const { LOGIN, SIGNUP } = PUBLIC_PATHS;

const {
  DASHBOARD,
  PERSONAL_ACC,
  CAC,
  CORP,
  NOTIFI,
  BVN,
  VERIFY_ID,
  ACC_STATEMENT,
  DEPOSIT,
  NIN,
  VOTE,
  INTER,
  BACK,
  DRIVE,
  EMPLOYEE,
  FRONT,
  INVITE_SIGNATORY,
  INFO,
  PAYMENT,
  REFERRAL,
  TRANSACTION,
  ACC_TYPE,
  MORE,
  ACC,
  TRANSFER,
  PERSONAL_ID,
} = PRIVATE_PATHS;

const Login = WithSuspense(lazy(() => import("../pages/Authentication/Login")));
const Signup = WithSuspense(
  lazy(() => import("../pages/Authentication/Signup"))
);
const Dashboard = WithSuspense(
  lazy(() => import("../pages/Home/Dashboard/Dashboard"))
);
const Payment = WithSuspense(lazy(() => import("../pages/Payment/Payment")));
const Transaction = WithSuspense(
  lazy(() => import("../pages/Transaction/Transaction"))
);
const Employee = WithSuspense(lazy(() => import("../pages/Employee/Employee")));
const Notifications = WithSuspense(
  lazy(() => import("../pages/Notifications/Notifications"))
);
const More = WithSuspense(lazy(() => import("../pages/More/More")));
const PersonalAccount = WithSuspense(
  lazy(() => import("../pages/Home/PrivateAccount/PersonalAccount"))
);
const Bvn = WithSuspense(lazy(() => import("../pages/Home/Bvn")));
const Info = WithSuspense(lazy(() => import("../pages/Home/Info")));
const Front = WithSuspense(lazy(() => import("../pages/Home/Front")));
const AccState = WithSuspense(
  lazy(() => import("../pages/Home/StatementAccount"))
);
const Back = WithSuspense(lazy(() => import("../pages/Home/Back")));
const PersonalId = WithSuspense(
  lazy(() => import("../pages/Home/PrivateAccount/PersonalID"))
);
const VerifyId = WithSuspense(
  lazy(() => import("../pages/Home/PrivateAccount/VerifyId"))
);
const Drive = WithSuspense(
  lazy(() => import("../pages/Home/PrivateAccount/Drive"))
);

const Nin = WithSuspense(
  lazy(() => import("../pages/Home/PrivateAccount/Nin"))
);

const Inter = WithSuspense(
  lazy(() => import("../pages/Home/PrivateAccount/Inter"))
);

const Voter = WithSuspense(
  lazy(() => import("../pages/Home/PrivateAccount/Voter"))
);

const Corp = WithSuspense(
  lazy(() => import("../pages/Home/CorporateAccount/Corp"))
);
const Acc = WithSuspense(lazy(() => import("../pages/Accounts/CreateAccount")));
const AccType = WithSuspense(lazy(() => import("../pages/Accounts/Type")));
const Referrall = WithSuspense(
  lazy(() => import("../pages/Referrall/Referrall"))
);
const Cac = WithSuspense(
  lazy(() => import("../pages/Home/CorporateAccount/Cac"))
);
const InviteSignatory = WithSuspense(
  lazy(() => import("../pages/Home/InviteSignatory"))
);
const Transfer = WithSuspense(lazy(() => import("../pages/Home/Transfer")));
const Deposit = WithSuspense(lazy(() => import("../pages/Home/Deposit")));

export const PUBLIC_ROUTES = [
  { path: LOGIN, element: <Login /> },
  { path: SIGNUP, element: <Signup /> },
  { path: "*", element: <Navigate to="/login" replace /> },
];
export const PRIVATE_ROUTES = [
  { path: DASHBOARD, element: <Dashboard /> },
  { path: PAYMENT, element: <Payment /> },
  { path: TRANSACTION, element: <Transaction /> },
  { path: MORE, element: <More /> },
  { path: ACC_TYPE, element: <AccType /> },
  { path: PERSONAL_ACC, element: <PersonalAccount /> },
  { path: NOTIFI, element: <Notifications /> },
  { path: EMPLOYEE, element: <Employee /> },
  { path: BVN, element: <Bvn /> },
  { path: INVITE_SIGNATORY, element: <InviteSignatory /> },
  { path: INFO, element: <Info /> },
  { path: PERSONAL_ID, element: <PersonalId /> },
  { path: VERIFY_ID, element: <VerifyId /> },
  { path: VOTE, element: <Voter /> },
  { path: FRONT, element: <Front /> },
  { path: BACK, element: <Back /> },
  { path: REFERRAL, element: <Referrall /> },
  { path: ACC_STATEMENT, element: <AccState /> },
  { path: INTER, element: <Inter /> },
  { path: DEPOSIT, element: <Deposit /> },
  { path: DRIVE, element: <Drive /> },
  { path: NIN, element: <Nin /> },
  { path: TRANSFER, element: <Transfer /> },
  { path: CORP, element: <Corp /> },
  { path: ACC, element: <Acc /> },
  { path: CAC, element: <Cac /> },
  { path: "*", element: <Navigate to="/dashboard" replace /> },
];
